import Icon, { IconsVariant } from "@/Components/Icon/Icon";
import { ReactNode } from "react";

interface ImageLibraryEmptyStateProps {
  icon?: IconsVariant;
  title: string;
  description?: string;
  action?: ReactNode;
}

const ImageLibraryEmptyState = ({
  icon = "search",
  title,
  description,
  action,
}: ImageLibraryEmptyStateProps) => (
  <div
    role="status"
    className="flex flex-col items-center justify-center rounded-[1rem] border border-dashed border-border bg-white px-8 py-24 text-center"
  >
    <div className="mb-6 flex h-[6rem] w-[6rem] items-center justify-center rounded-full bg-light">
      <Icon className="h-[2.4rem] w-[2.4rem] fill-text-secondary" variants={icon} />
    </div>
    <div className="text-[1.8rem] font-semibold text-text">{title}</div>
    {description && (
      <div className="mt-2 max-w-[44rem] text-small text-text-secondary">
        {description}
      </div>
    )}
    {action && <div className="mt-8">{action}</div>}
  </div>
);

export default ImageLibraryEmptyState;
